import Character,{ type CharacterId,type Look } from './Characters'
import { personalityById } from '../../shared/market/personalities'
import { getLocale } from '../lib/i18n'

export interface AvatarData { character: string; personality?: string; look: Look }

/** A neighbor's island character in a round frame, or their first letter when they have not picked one yet. */
export default function Avatar({avatar,name,size=44,className=''}:{avatar?:AvatarData|null;name:string;size?:number;className?:string}){
 if(!avatar)return <span className={`avatar initial ${className}`} style={{width:size,height:size,fontSize:Math.round(size*0.42)}} aria-hidden="true">{name.charAt(0).toUpperCase()}</span>
 const p=personalityById(avatar.personality)
 return <span className={`avatar bg-${avatar.look.bg??'sand'} ${className}`} style={{width:size,height:size}} title={p?(getLocale()==='en'?p.title.en:p.title.es):undefined} aria-hidden="true"><Character id={avatar.character as CharacterId} look={avatar.look} size={Math.round(size*0.92)}/></span>
}
